//------------------------------------------------------ funciones
import { supabase } from "../supabase/SupabaseClient";

// Invoca la edge function consultar-scania y devuelve siempre
// { data, error }, con error ya como string legible.
//
// Antes cada pantalla (Combustible, Viajes) repetía esta lógica a
// mano, y el mensaje de error terminaba siendo el genérico del SDK
// ("Edge Function returned a non-2xx status code") en vez del motivo
// real -- que viaja en el body de la respuesta de la función, pero
// el SDK no lo lee solo (queda en fnError.context, un Response sin
// consumir). Centralizado acá para que el fix no se desincronice
// entre pantallas otra vez.
export const consultarScania = async ({ interno, desde, hasta }) => {
  try {
    const { data, error: fnError } = await supabase.functions.invoke(
      "consultar-scania",
      { body: { interno, desde, hasta } },
    );

    if (fnError || data?.error) {
      let mensajeReal = data?.error;
      if (!mensajeReal && fnError?.context?.json) {
        try {
          const body = await fnError.context.json();
          mensajeReal = body?.error;
        } catch {
          // el body no era JSON (ej. timeout del gateway antes de
          // llegar a nuestro código) -- seguimos con fnError.message.
        }
      }
      return {
        data: null,
        error: mensajeReal || fnError?.message || "Error desconocido",
      };
    }

    return { data, error: null };
  } catch (e) {
    return { data: null, error: e?.message || "Error desconocido" };
  }
};
